export default ({ setCssVars, srv }) => {
	let cssVars = srv('cssVars')
	for (let cssSelector in cssVars) {
		setCssVars(cssSelector, cssVars[cssSelector])
	}
}
